import React from 'react';
import { Input } from '../../../shared/components';
//import './VitalsForm.css';

const VitalsForm = ({ vitals, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  return (
    <div className="vitals-form">
      <div className="vitals-grid">
        <Input
          label="Temperature (°C)"
          name="temperature"
          type="number"
          step="0.1"
          value={vitals.temperature}
          onChange={handleChange}
          placeholder="36.6"
        />
        
        <Input
          label="Heart Rate (bpm)"
          name="heart_rate"
          type="number"
          value={vitals.heart_rate}
          onChange={handleChange}
          placeholder="72"
        />
        
        <div className="blood-pressure">
          <Input
            label="BP Systolic"
            name="blood_pressure_systolic"
            type="number"
            value={vitals.blood_pressure_systolic}
            onChange={handleChange}
            placeholder="120"
          />
          <span className="separator">/</span>
          <Input
            label="BP Diastolic"
            name="blood_pressure_diastolic"
            type="number"
            value={vitals.blood_pressure_diastolic}
            onChange={handleChange}
            placeholder="80"
          />
        </div>
        
        <Input
          label="Respiratory Rate"
          name="respiratory_rate"
          type="number"
          value={vitals.respiratory_rate}
          onChange={handleChange}
          placeholder="16"
        />
        
        <Input
          label="O2 Saturation (%)"
          name="oxygen_saturation"
          type="number"
          value={vitals.oxygen_saturation}
          onChange={handleChange}
          placeholder="98"
        />
        
        <Input
          label="Weight (kg)"
          name="weight"
          type="number"
          step="0.1"
          value={vitals.weight}
          onChange={handleChange}
          placeholder="70"
        />
        
        <Input
          label="Height (cm)"
          name="height"
          type="number"
          value={vitals.height}
          onChange={handleChange}
          placeholder="170"
        />
      </div>
      
      <div className="vitals-notes">
        <label>Additional Notes</label>
        <textarea
          name="notes"
          value={vitals.notes}
          onChange={handleChange}
          placeholder="Any additional observations or notes..."
          rows="4"
        />
      </div>
    </div>
  );
};

export default VitalsForm;